// 🔕 F4 (Nina 09-26, PORTED_HOME_HANDOFF §3 ruling 29: "silence the chime"):
// which sound, if any, an incoming spectating_message plays. The page calls
// this from processIncomingAction (a useCallback with empty deps), so every
// input arrives as a render-synced ref value.
//
//   'moderator'  a host line, in every room EXCEPT a ported one (a 1:1 room
//                has no visible host: its host lines are hidden, and a chime
//                for a line nobody can see is the host in the room anyway)
//   'whisper'    ghost chatter the viewer can't see right now (panel
//                collapsed, or open but scrolled up); never in a Live room,
//                whose feed shows every crowd line. Unchanged from before.
//   null         nothing
//
// A moderator line never falls through to the whisper rule (it never did:
// before this, the whisper was the `else` of the moderator branch).
export function spectatingCue(data, {
  silent = false,
  ported = false,
  crowdInline = false,
  panelExpanded = true,
  panelScrolledUp = false,
} = {}) {
  if (!data || silent) return null;
  if (data.is_moderator) return ported ? null : 'moderator';
  if (data.is_ghost_chatter && !crowdInline && (!panelExpanded || panelScrolledUp)) return 'whisper';
  return null;
}
